import styled, { css } from 'styled-components'
import { Popover } from 'antd'
import { themeColor, UITypes } from 'LibNeo'

export const PopoverStyled = styled(Popover)`
	width: 100%;
`

export const PopoverOverlayStyled = styled.div<{ type: UITypes }>`
	z-index: 1500;

	${({ type }) =>
		type === UITypes.BLACK &&
		css`
			.ant-popover-placement-top,
			.ant-popover-placement-topLeft,
			.ant-popover-placement-topRight {
				& > .ant-popover-content {
					& > .ant-popover-arrow {
						border-bottom-color: ${themeColor('extraBackground3')};
						border-right-color: ${themeColor('extraBackground3')};
					}
				}
			}
			.ant-popover-placement-bottom,
			.ant-popover-placement-bottomLeft,
			.ant-popover-placement-bottomRight {
				& > .ant-popover-content {
					& > .ant-popover-arrow {
						border-top-color: ${themeColor('extraBackground3')};
						border-left-color: ${themeColor('extraBackground3')};
					}
				}
			}
			.ant-popover-placement-left,
			.ant-popover-placement-leftTop,
			.ant-popover-placement-leftBottom {
				& > .ant-popover-content {
					& > .ant-popover-arrow {
						border-top-color: ${themeColor('extraBackground3')};
						border-right-color: ${themeColor('extraBackground3')};
					}
				}
			}
			.ant-popover-placement-right,
			.ant-popover-placement-rightTop,
			.ant-popover-placement-rightBottom {
				& > .ant-popover-content {
					& > .ant-popover-arrow {
						border-bottom-color: ${themeColor('extraBackground3')};
						border-left-color: ${themeColor('extraBackground3')};
					}
				}
			}
		`}
`
